import styled from "styled-components";

const TreeIdentifier = styled.span`
  padding-left: 7px;
`;

export default TreeIdentifier;
